import moment from 'moment'
import { TFunction, useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { IWhitelabelContext, useWhitelabel } from 'main/framework'
import { IMonthsRange } from 'main/gql/schoolAgeGroup'
import { AssetName } from 'main/util/asset'
import { DATE_FORMAT } from 'main/util/date'

export function formatAge(months: number) {
  const { t } = useTranslation(NAMESPACE)
  const whitelabel = useWhitelabel()

  return formatAgeForTuitionModal(months, whitelabel, t)
}

export function formatAgeWithTranslation(months: number, t: TFunction) {
  const whitelabel = useWhitelabel()

  return formatAgeForTuitionModal(months, whitelabel, t)
}

export function formatAgeForTuitionModal(
  months: number,
  whitelabel: IWhitelabelContext,
  t: TFunction<string, undefined>,
) {
  const halfYears = Math.floor(months / 6)
  const years = Math.floor(months / 12)

  if (
    whitelabel.evaluateToFalseExceptIfTrue(AssetName.AGE_RANGE_START_AT_SIX_WEEKS) &&
    months <= 1
  ) {
    return t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-AGE-RANGE-MODAL-EDIT-SELECT-6-WEEKS')
  }

  // {{count}} month
  if (months === 1) {
    return t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-AGE-RANGE-MODAL-EDIT-SELECT-MONTH-SINGULAR', {
      count: months,
    })
  }

  // {{count}} months
  if (months < 24) {
    return t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-AGE-RANGE-MODAL-EDIT-SELECT-MONTH-PLURAL', {
      count: months,
    })
  }

  // include half-years when age is less than 5 years
  if (years < 5 && halfYears % 2 !== 0) {
    return `${years}.5 ${t(
      'DASHBOARD-PAYMENTS-TUITION-SETTINGS-AGE-RANGE-MODAL-EDIT-SELECT-YEARS',
    )}`
  }

  return `${years} ${t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-AGE-RANGE-MODAL-EDIT-SELECT-YEARS')}`
}

export function formatAgeFromBirthdate(birthdate: string) {
  const months = moment().diff(moment(birthdate, DATE_FORMAT, true), 'months')

  return formatAge(months > 0 ? months : 0)
}

export function formatAgeRange(ageRange: IMonthsRange): string {
  const { t } = useTranslation(NAMESPACE)
  const { min, max } = ageRange

  const whitelabel = useWhitelabel()

  if (whitelabel.evaluateToFalseExceptIfTrue(AssetName.AGE_RANGE_START_AT_SIX_WEEKS)) {
    if (max <= 1) {
      return t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-TAB-TITLE-ONLY-6-WEEKS')
    }

    if (min <= 1) {
      return t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-TAB-TITLE-START-6-WEEKS', { max })
    }
  }

  return t('DASHBOARD-PAYMENTS-TUITION-SETTINGS-TAB-TITLE', { min, max }) // can use a dash between two values
}
